import React, { Component } from 'react';
import './KPI2.css';

// product filter => orbit.anx_date_time

import Select from '@acri-tools/react-tools/components/Select/Select';
import KPIs from '../KPIs';
import { getDateTimeString } from '@acri-tools/react-tools/utils/date';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

// import DATA from './data';

import FormFieldCheckbox from '@acri-tools/react-tools/components/FormFieldCheckbox/FormFieldCheckbox';
import { API_URL } from '../../../_utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { axiosErrorHandler, nullUndefined } from '@acri-tools/react-tools/utils/global';
import KPITable from '../../../components/KPITable/KPITable';
import { connect } from 'react-redux';
import { date_timezone_compensated, get_graph_mode, get_month_dates, get_timeline_height, is_on_kpi_page, update_kpi_url } from '../../../_utils/kpi';
import classNames from 'classnames';
import { load_product_types } from '../../../_utils/product_types';
import { to_local_iso_string } from '../../../_utils/date';
import KPIRefreshOverlay from '../../../components/KPIRefreshOverlay/KPIRefreshOverlay';
// Chart.register(zoomPlugin);
import Chart from 'react-apexcharts';
import moment from 'moment';
import TimelinessChart from '../../../components/TimelinessChart/TimelinessChart';
import { LogDuration } from '../../../_utils/general';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';

// const FILTER_TIME_MAX = 1000*60*60*24*7;
const FILTER_TIME_MAX = 1000*60*60*24;

interface Props {
    // REDUX
    product_types?: any
    kpi?: any
}
interface State {
    refreshing: boolean
    loading: boolean

    graph_modes?: Array<any>
    graphMode?: any
    base_graphMode?: string

    startDate: string
    stopDate: string

    base_startDate?: string
    base_stopDate?: string

    updateStartDate: string
    updateStopDate: string

    // data
    orbit?: any[]
    orbit_graph_data?: any[]
    
    timeline_rows: number
    data_labels?: string[]

    data?: any
    data_graph_data?: any[]

    graph_data?: any[]

    // product_types
    toggled_products: { [key: string]: boolean }

    // chart
    chart_data?: any
    drag_mode: boolean
    // export
    json_format: boolean
}

const DATE_FILTER = 'stop_date_time';

/**
 * KPI ->
 * List of dynamic KPI per product type / mode values ->
 * Details KPI using timeline product_type / mode => graph / data with orbit.start
 */

class KPI2 extends Component<Props, State> {
    ref: any
    chart: any

    constructor(props: Props) {
        super(props);

        this.ref = React.createRef();

        this.state = {
            timeline_rows: 1,
            refreshing: false,
            loading: false,
            toggled_products: {},
            json_format: false,
            drag_mode: false,
            ...this.default_values(true)
        }
    }

    default_values = (set_base?: boolean) => {
        return {
            ...get_graph_mode(this.state, set_base, this.state?.graph_modes),
            ...get_month_dates(this.state, set_base)
        }
    }

    async componentDidMount() {
        await load_product_types()
        await this.fetch_graph_modes();
        this.default_values(true)

        this.fetch_data(true)
    }
    async componentDidUpdate(prevProps: Props) {
        if (prevProps.kpi?.refresh !== this.props.kpi?.refresh) {
            await this.setState({
                ...this.default_values(true)
            })
            if (is_on_kpi_page(2)) {
                this.update_url()
            }
            this.fetch_data(true)
        }
    }

    get_graph_mode = () => {
        return this.state.graphMode ? this.state.graph_modes?.find((gm: any) => gm.name === this.state.graphMode) : null;
    }


    fetch_graph_modes = async () => {
        try {
            let res = await request(`${API_URL}/api/v1/kpi_2_graph_modes`, {
                method: 'get',
            })
            await this.setState({
                graph_modes: res.data.value,
                ...get_graph_mode(this.state, true, res.data.value)
            })
        }
        catch (e) {
            axiosErrorHandler(e, {
                functionName: 'fetch_graph_modes'
            })
        }
    }

    fetch_data = async (refresh?: boolean) => {
        let duration = new LogDuration();
        let graphMode = this.get_graph_mode();
        if (!graphMode) return;
        
        duration.time_since('fetch graph mode');
        if (refresh) this.setState({ refreshing: true, loading: true });
        else this.setState({ loading: true });

        create_toast({ type: 'info', duration: 60, message: `Due to the amount of data to load on the graph, the request might take some time to load.` })

        try {
            let promises = [];
            let gm_products = graphMode?.products;
            let data:any = {};
            let data_graph_data = [];
            // if (refresh) await this.setState({ data: {}, data_graph_data: [] });

            promises.push(this.fetch_orbit_data());
            if (gm_products) {
                if (refresh) {
                    let toggled_products: any = {};
                    gm_products.forEach((product: any, idx: number) => {
                        toggled_products[idx] = true;
                    })
                    await this.setState({ toggled_products })
                }

                gm_products.forEach((product: any, idx: number) => {
                    promises.push(this.fetch_kpi_data(product, idx));
                })
            }

            let results:any[] = await Promise.all(promises);
            duration.time_since('fetch all data');

            // console.debug("results", results);
            
            // ORBIT DATA
            let orbit_data:any = results.shift();
            let orbit_graph_data:Array<any> = [];
            if(orbit_data){
                try{
                    orbit_data.forEach((d:any, key:number)=>{
                        if(!d.next_anx_date_time) return;
                        orbit_graph_data.push({
                            name: `Orbit ${d.orbit_number}`,
                            data:[{
                                x: "Orbits",
                                y: [
                                    date_timezone_compensated(d.anx_date_time)?.getTime(),
                                    date_timezone_compensated(d.next_anx_date_time)?.getTime()
                                ],
                                fillColor: key % 2 === 0 ? "#2dbf35" : "#8ecc82"
                            }],
                        })
                    });
                }
                catch(e){
                    console.error('format orbit graph data error', e);
                }
            }
            duration.time_since('format orbits');


            // KPI DATA
            let i = 0;
            for(let product_data of results){
                if(product_data){
                    try{
                        data[i] = product_data;
                        data_graph_data[i] = product_data.map((d: any, key:number) => {
                            return {
                                name: d.product_name,
                                data: [{
                                    x: this.product_string(gm_products[i]),
                                    y: [
                                        date_timezone_compensated(d.start_date_time)?.getTime(),
                                        date_timezone_compensated(d.stop_date_time)?.getTime(),
                                    ],
                                    fillColor: key % 2 === 0 ? "#326ce5" : "#90aeee"
                                }]
                            }
                        })
                    }
                    catch(e){
                        console.error('product graph data formatting error', e);
                    }
                }
                i++;
            }
            duration.time_since('format product data');

            await this.setState({ 
                data, 
                data_graph_data, 
                orbit_graph_data,
                orbit: orbit_data, 
                data_labels: this.get_data_labels(), 
                timeline_rows: ( gm_products?.length || 0) + 1,
                graph_data: this.set_graph_data(orbit_graph_data, data_graph_data),
            });
            

            duration.time_since('set graph data');
            // console.debug("data_graph_data", this.state.data_graph_data);
        }
        catch (e) {
            console.error('fetch_data error', e);
        }
        finally {
            if (refresh) this.setState({ refreshing: false, loading: false });
            else this.setState({ loading: false });
        }
    }

    fetch_kpi_data = async (product: any, index: number):Promise<any[]|undefined> => {
        try {
            let { product_type, mode } = product;
            if (nullUndefined(product_type)) {
                console.error(`Error fetching product type id`);
                return undefined;
            }
            if (nullUndefined(mode)) {
                console.error(`Error fetching product mode`);
                return undefined;
            }

            let res = await request(`${API_URL}/api/v1/products`, {
                method: 'get',
                params: {
                    // limit: 50,
                    limit: 4500,
                    orderby: `start_date_time DESC`,
                    expand: 'orbit',
                    // filter: `
                    //     product_type eq '${product_type}'
                    //     and start_date_time ge '${getDateTimeString(this.state.startDate, true, true)}'
                    //     and start_date_time le '${getDateTimeString(this.state.stopDate, true, true)}'
                    // `
                    filter: `
                        product_type eq '${product_type}'
                        and ${DATE_FILTER} ge '${this.state.startDate}'
                        and ${DATE_FILTER} le '${this.state.stopDate}'
                        and mode eq '${mode}'
                    `
                }
            })

            return res.data.value;
        }
        catch (e) {
            axiosErrorHandler(e, {
                functionName: 'fetch_kpi_data'
            })
            return undefined;
        }
    }
    fetch_orbit_data = async () => {
        try {
            const hours = 2;
            let start = new Date(new Date(this.state.startDate).getTime() - hours * 60 * 60 * 1000);
            let stop = new Date(new Date(this.state.stopDate).getTime() + hours * 60 * 60 * 1000);

            let res = await request(`${API_URL}/api/v1/orbits`, {
                method: 'get',
                params: {
                    limit: 4500,
                    // filter: `product_type eq 4
                    //     and sensing_product.start_date_time ge '${this.state.startDate}'
                    //     and sensing_product.stop_date_time le '${this.state.stopDate}'`
                    filter: `anx_date_time ge '${getDateTimeString(start, true, true)}' 
                        and anx_date_time le '${getDateTimeString(stop, true, true)}'
                        and satellite eq 'S3A'
                        `,
                    orderby: 'anx_date_time DESC'
                }
            })

            let last_orbit_date;
            for (let orbit of res.data.value) {
                if (last_orbit_date) orbit.next_anx_date_time = last_orbit_date;
                last_orbit_date = orbit.anx_date_time;
            }

            return res.data.value;
        }
        catch (e) {
            axiosErrorHandler(e, {
                functionName: 'fetch_orbit_data',
            })
        }
    }

    update_url = () => {
        update_kpi_url(2, {
            startDate: to_local_iso_string(this.state.startDate),
            stopDate: to_local_iso_string(this.state.stopDate),
            // startDate: to_local_iso_string(this.state.startDate),
            // stopDate: to_local_iso_string(this.state.stopDate),
            graphMode: this.state.graphMode
        })
    }

    applyChanges = async () => {
        await this.setState({
            startDate: this.state.updateStartDate,
            stopDate: this.state.updateStopDate
        })
        this.update_url()
        this.fetch_data()
    }

    reset = async () => {
        await this.setState({
            ...this.default_values()
        })
        this.update_url()
        this.fetch_data(true)
    }

    get_toggled_products = () => {
        // return Object.keys(this.state.toggled_products).filter((product:string, idx:number)=> this.state.toggled_products[idx] ) || [];
        let graphMode = this.get_graph_mode();
        return graphMode?.products.filter((product: any, idx: number) => this.state.toggled_products[idx]);
    }

    product_string = (product: any, new_line?: boolean) => {
        if (new_line) {
            return `${product.product_type}\n${product.mode}${product.pug ? ', PUG' : ''}`
        }
        return `${product.product_type}, ${product.mode}${product.pug ? ', PUG' : ''}`;
    }

    get_data_labels = () =>{
        let data_labels:string[] = [
            'Orbits'
        ];
        let toggled_products = this.get_toggled_products();

        toggled_products?.forEach((tp:any)=>{
            data_labels.push(this.product_string(tp))
        })

        return data_labels.length > 0 ? data_labels : undefined
    }
    get_timeline_rows = () =>{
        return (this.get_toggled_products()?.length || 0) + 1;
    }

    set_graph_data = (orbit_graph_data?:any, data_graph_data?:any) =>{
        let toggled_products = this.get_toggled_products();
        if(!orbit_graph_data) orbit_graph_data = this.state.orbit_graph_data;
        if(!data_graph_data) data_graph_data = this.state.data_graph_data;

        let graph_data:Array<any> = [
            ...orbit_graph_data || []
        ];
        toggled_products?.forEach((p: any,) => {
            let idx = this.get_product_index(p);
            graph_data.push(...data_graph_data?.[idx] || []);
        });

        return graph_data;

        // this.setState({ graph_data })
    }
    
    update_toggled_products = async(toggled_products: any) => {
        await this.setState({ toggled_products});
        this.setState({ 
            timeline_rows: this.get_timeline_rows(),
            data_labels: this.get_data_labels(),
            graph_data: this.set_graph_data()
        });        
    }

    render() {
        let graphMode = this.get_graph_mode();
        let toggled_products = this.get_toggled_products();

        // let date_surpassed = (new Date(this.state.updateStopDate).getTime() - new Date(this.state.updateStartDate).getTime()) > FILTER_TIME_MAX;
        return (
            <KPIs
                title="Production Completeness"
            >
                <div className="row-2">
                    <div className="row-2">
                        <div className="form-field">
                            <label>Start Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStartDate}
                                onChange={async (e) => {
                                    this.setState({ updateStartDate: e.target.value });
                                }}
                            />
                        </div>
                        <div className="form-field">
                            <label>Stop Date</label>
                            <input type="datetime-local"
                                value={this.state.updateStopDate}
                                onChange={async (e) => {
                                    this.setState({ updateStopDate: e.target.value });
                                }}
                            />
                        </div>
                    </div>
                    <div className="row-2">
                        {
                            this.state.graph_modes &&
                            <div className="form-field">
                                <label>Select Graph Mode</label>
                                <Select
                                    search
                                    value={this.state.graphMode}
                                    onChange={async (graphMode: any) => {
                                        await this.setState({ graphMode });
                                        this.update_url()
                                        this.fetch_data(true)
                                    }}
                                    // options={this.state.graph_modes.map((gm) => { return { label: gm.name, value: gm } })}
                                    options={this.state.graph_modes.map((gm) => { return { label: gm.name, value: gm.name } })}
                                />
                            </div>
                        }
                    </div>
                </div>

                <div className="filter-buttons">
                    <div 
                        className={classNames({
                            "button-with-dialog": true,
                            // "dialog-actif": date_surpassed
                        })} 
                    >
                        <div className={
                            classNames({
                                "custom-button small alt inline apply-changes": true,
                                "disabled": !(
                                    this.state.updateStartDate !== this.state.startDate
                                    || this.state.updateStopDate !== this.state.stopDate
                                ) 
                                // || date_surpassed
                            })}
                            onClick={this.applyChanges}
                        >
                            <i className="fas fa-check" /> Apply Changes
                        </div>
                        {
                            // date_surpassed &&
                            // <div className="custom-button-dialog">
                            //     Please select a smaller time frame. 1 Day max.
                            // </div>
                        }
                    </div>
                </div>

                <div className="custom-button small alt inline" onClick={this.reset}>
                    <i className="fas fa-redo-alt" /> Reset Filters
                </div>
                <br />
                <br />

                <div className="row-2">
                    <div className="measurements">
                        <div className="form-field">
                            <label>Product types</label>
                        </div>
                        <FormFieldCheckbox
                            notSolid
                            label="All"
                            value={Object.keys(this.state.toggled_products)?.every((v) => this.state.toggled_products[v])}
                            onChange={(val: boolean) => {
                                let { toggled_products } = this.state;
                                for (let t in toggled_products) {
                                    toggled_products[t] = val
                                }
                                this.update_toggled_products(toggled_products);
                            }}
                        />
                        {
                            graphMode?.products.map((product: any, idx: number) => (
                                <FormFieldCheckbox
                                    key={idx}
                                    notSolid
                                    label={<>
                                        {this.product_string(product)}
                                        {
                                            this.state.data && this.state.data[idx] &&
                                            <span className="counter">{this.state.data[idx].length}</span>}</>
                                    }
                                    value={this.state.toggled_products[idx]}
                                    onChange={async(val: boolean) => {
                                        let { toggled_products } = this.state;
                                        toggled_products[idx] = val;
                                        this.update_toggled_products(toggled_products);
                                    }}
                                />
                            ))
                        }
                    </div>

                </div>

                <br />
                <br />
                <div className="title-3">Results</div>
                <Tabs
                    tabs={[
                        {
                            label: <><i className="fas fa-chart-bar" /> Graph</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                        <div className="centered">
                                            <Spinner />
                                        </div>
                                        :
                                        <>
                                            <FormFieldCheckbox
                                                notSolid label="Drag Mode"
                                                disabled
                                                // value={this.state.drag_mode}
                                                value={true}
                                                // onChange={(drag_mode: boolean) => { this.setState({ drag_mode }) }}
                                                onChange={(drag_mode: boolean) => { }}
                                            />
                                            {
                                                this.state.data && this.state.orbit && graphMode &&
                                                <div className="kpi-graph kpi-2-graph" 
                                                    // style={{
                                                    //     height: timeline_height
                                                    // }}
                                                >
                                                    {
                                                        this.state.loading &&
                                                        <KPIRefreshOverlay message="Fetching data..." />
                                                    }
                                                    {/* TIMELINESS CHART */}
                                                    {
                                                        this.state.data_graph_data &&
                                                        <TimelinessChart 
                                                            // drag_mode={this.state.drag_mode}
                                                            data={this.state.graph_data}
                                                            startDate={this.state.startDate}
                                                            stopDate={this.state.stopDate}
                                                            timeline_rows={this.state.timeline_rows}
                                                            data_labels={this.state.data_labels}
                                                            // data_labels={this.get_data_labels()}
                                                            zoom_update={async(startDate, stopDate)=>{
                                                                try {
                                                                    let start = getDateTimeString(new Date(startDate), true, true);
                                                                    let stop = getDateTimeString(new Date(stopDate), true, true);
                                                                    await this.setState({
                                                                        startDate: start,
                                                                        stopDate: stop,
                                                                        updateStartDate: start,
                                                                        updateStopDate: stop
                                                                    })
                                                                    this.update_url()
                                                                    this.fetch_data()
                                                                }
                                                                catch (e) {
                                                                    console.error('onZoomComplete',e);
                                                                }
                                                            }}
                                                        />
                                                    }
                                                </div>
                                            }
                                        </>
                                }

                            </div>
                        },
                        {
                            label: <><i className="fas fa-th-list" /> Data</>,
                            content: <div className="kpi-data">
                                {
                                    this.state.refreshing ?
                                        <div className="centered">
                                            <Spinner />
                                        </div>
                                        :
                                        <>
                                            {
                                                this.state.data &&
                                                toggled_products.map((p: any) => {
                                                    let idx = this.get_product_index(p)
                                                    return (
                                                        <KPITable key={idx} title={`Production Completeness ${this.product_string(p)}`} counter={this.state.data[idx]?.length}>

                                                            {
                                                                this.state.loading &&
                                                                <KPIRefreshOverlay message="Fetching data..." />
                                                            }
                                                            <table className="table-kpi">
                                                                <thead>
                                                                    <tr>
                                                                        {/* <th style={{ width:"300px" }}>Product</th> */}
                                                                        <th >Product</th>
                                                                        {/* <th>Mode</th> */}
                                                                        <th>Start</th>
                                                                        <th>Stop</th>
                                                                        {/* <th>Gap</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        this.state.data[idx]?.map((d: any, key: number) => (
                                                                            <tr key={key}>
                                                                                <td width={300}>{d.product_name}</td>
                                                                                {/* <td>{this.state.mode}</td> */}
                                                                                <td>{d.start_date_time}</td>
                                                                                <td>{d.stop_date_time}</td>
                                                                                {/* <td>{d.gap}</td> */}
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </KPITable>
                                                    )
                                                })
                                            }
                                        </>
                                }
                            </div>
                        }
                    ]}
                />



                <br />
                <br />
                {/* DOWNLOAD */}
                <div className="title-3">Export</div>
                <p>Export Data used to compute the KPI</p>
                <FormFieldCheckbox
                    notSolid label="JSON Format"
                    value={!!this.state.json_format}
                    onChange={(json_format: boolean) => { this.setState({ json_format }) }}
                />

                <a
                    className={classNames({
                        "custom-button medium inline": true,
                        "disabled": toggled_products?.length === 0
                    })}
                    href={this.download_url()} download
                >
                    <i className="fas fa-cloud-download-alt" /> Export
                </a>
            </KPIs>
        );
    }
    get_product_index = (product: any) => {
        let graphMode = this.get_graph_mode();
        return graphMode?.products?.indexOf(product);
    }

    gap = (d: any) => {
        let start = new Date(d[0]);
        let stop = new Date(d[1]);
        return (stop.getTime() - start.getTime()) / 1000;
    }


    download_url = () => {
        let indexes = this.get_toggled_products()?.map((p: any) => {
            return this.get_product_index(p);
        });
        let params = [
            'export=true',
            `graph_mode=${this.state.graphMode}`,
            `exports=${indexes?.join(',')}`,
            `start_date=${this.state.startDate}`,
            `stop_date=${this.state.stopDate}`
        ];
        if (this.state.json_format) params.push('format=json');
        return `${API_URL}/api/v1/kpi_2?${params.join('&')}`
    }


};

export default connect((state: any) => {
    return {
        product_types: state.product_types,
        kpi: state.kpi
    }
})(KPI2)